/**
 * "Find your stack" quiz. 5 single-choice questions, then a recommendation.
 * Safety answers (age, pregnancy, anticoagulants, caffeine, sex) remove
 * formulas that are not suitable and say why — the quiz is allowed to
 * recommend nothing. Product/price data is rendered server-side into
 * [data-ch-quiz-data]; adding to cart goes through window.CellhackCart.
 */
(function () {
  const root = document.querySelector('[data-ch-quiz]');
  if (!root) return;

  let data = { products: {}, stacks: {} };
  try {
    data = JSON.parse(document.querySelector('[data-ch-quiz-data]').textContent);
  } catch (error) {
    console.error('[quiz] bad data', error);
  }

  const panels = Array.from(root.querySelectorAll('[data-ch-quiz-q]'));
  const steps = root.querySelector('[data-ch-quiz-steps]');
  const labelEl = root.querySelector('[data-ch-quiz-label]');
  const percentEl = root.querySelector('[data-ch-quiz-percent]');
  const barEl = root.querySelector('[data-ch-quiz-bar]');
  const actions = root.querySelector('[data-ch-quiz-actions]');
  const backBtn = root.querySelector('[data-ch-quiz-back]');
  const nextBtn = root.querySelector('[data-ch-quiz-next]');
  const resultEl = root.querySelector('[data-ch-quiz-result]');
  const total = panels.length;
  const answers = {};
  let index = 0;

  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function show(i) {
    index = i;
    panels.forEach((panel, n) => { panel.hidden = n !== i; });
    const id = panels[i].getAttribute('data-ch-quiz-q');
    panels[i].querySelectorAll('.ch-quiz__option').forEach((opt) => {
      const on = opt.getAttribute('data-value') === answers[id];
      opt.classList.toggle('is-selected', on);
      opt.setAttribute('aria-checked', String(on));
    });
    const pct = Math.round(((i + 1) / total) * 100);
    labelEl.textContent = 'QUESTION ' + String(i + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
    percentEl.textContent = pct + '%';
    barEl.style.width = pct + '%';
    backBtn.hidden = i === 0;
    nextBtn.disabled = !answers[id];
    nextBtn.innerHTML = i === total - 1 ? 'See my result &rarr;' : 'Next &rarr;';
  }

  panels.forEach((panel) => {
    const id = panel.getAttribute('data-ch-quiz-q');
    panel.querySelectorAll('.ch-quiz__option').forEach((opt) => {
      opt.addEventListener('click', () => {
        answers[id] = opt.getAttribute('data-value');
        show(index);
      });
    });
  });

  backBtn.addEventListener('click', () => { if (index > 0) show(index - 1); });
  nextBtn.addEventListener('click', () => {
    const id = panels[index].getAttribute('data-ch-quiz-q');
    if (!answers[id]) return;
    if (index < total - 1) show(index + 1);
    else showResult();
  });

  // Recommendation ---------------------------------------------------------
  function recommend(a) {
    if (a.who === 'under18' || a.who === 'pregnant') {
      return {
        keys: [],
        notes: [],
        none: a.who === 'under18'
          ? 'Our formulas are intended for adults, so we have no recommendation for someone under 18.'
          : 'We do not recommend any of our formulas during pregnancy or breastfeeding. Please speak to your doctor or midwife about what is right for you.'
      };
    }
    let want;
    if (a.goal === 'hormones') want = ['toro', 'd3k2'];
    else if (a.goal === 'health') want = ['d3k2'];
    else if (a.goal === 'energy') want = ['body', 'd3k2'];
    else want = a.train === 'daily' || a.train === 'often' ? ['body', 'd3k2'] : ['d3k2'];

    const notes = [];
    const ok = {
      toro: a.who === 'adult_m',
      d3k2: a.health !== 'anticoag',
      body: a.caffeine === 'none' || a.caffeine === 'low'
    };
    const left = {
      toro: 'Toro Prime™ is formulated for men, so we have left it out.',
      d3k2: 'You take anticoagulant medication. Vitamin K can affect how it works, so we have left CellHack D3 + K2 out. Ask your doctor.',
      body: 'Body Drive contains 150 mg of caffeine per serving, so we have left it out based on your caffeine answer.'
    };
    const keys = want.filter((k) => ok[k] && data.products[k]);
    want.forEach((k) => { if (!ok[k]) notes.push(left[k]); });

    if (keys.indexOf('toro') > -1 && keys.indexOf('d3k2') > -1) {
      notes.push('Toro Prime™ (25 µg D3) plus D3 + K2 (75 µg) gives 100 µg of vitamin D a day, the adult upper limit. Do not add other vitamin D supplements.');
    }
    if (keys.indexOf('body') > -1) {
      notes.push('Body Drive has 150 mg of caffeine per serving. Count it towards your daily caffeine and take it before 2pm.');
    }
    if (a.health === 'other') {
      notes.push('You take medication or have a medical condition, so speak to your doctor before starting any supplement.');
    }
    return { keys: keys, notes: notes, none: keys.length ? '' : 'None of our formulas fit the answers you gave. That is the right answer for you right now.' };
  }

  function stackFor(keys) {
    const s = keys.slice().sort().join('+');
    if (s === 'd3k2+toro') return data.stacks.foundation;
    if (s === 'body+d3k2') return data.stacks.body;
    if (s === 'body+d3k2+toro') return data.stacks.full;
    return null;
  }

  function showResult() {
    const rec = recommend(answers);
    const items = rec.keys.map((k) => data.products[k]);
    const stack = rec.keys.length > 1 ? stackFor(rec.keys) : null;
    steps.hidden = true;
    root.querySelectorAll('.ch-quiz__panel').forEach((p) => { p.hidden = true; });
    actions.hidden = true;

    let html = '<span class="ch-eyebrow">Your result</span>';
    if (!items.length) {
      html += '<h3 class="ch-quiz__question">No recommendation right now.</h3><p class="ch-quiz__result-copy">' + esc(rec.none) + '</p>';
    } else {
      const title = stack ? stack.title : items.length === 1 ? items[0].title : 'Your stack';
      html += '<h3 class="ch-quiz__question">' + esc(title) + '</h3>';
      html += '<ul class="ch-quiz__items">' + items.map((p) =>
        '<li class="ch-quiz__item">' +
        '<span class="ch-quiz__item-thumb ch-placeholder">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</span>' +
        '<span class="ch-quiz__item-text"><a class="ch-quiz__item-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="ch-quiz__item-line">' + esc(p.line) + '</span></span>' +
        '<span class="ch-quiz__item-price">' + esc(p.price) + '</span></li>'
      ).join('') + '</ul>';
      if (stack) {
        html += '<p class="ch-quiz__result-copy">Bundled: ' + esc(stack.price) + (stack.hasCompare ? ' <s>' + esc(stack.compare) + '</s>' : '') + ' instead of buying each separately.</p>';
        html += '<button type="button" class="ch-quiz__cta ch-quiz__cta--button" data-ch-quiz-add="stack">Add stack to cart &middot; ' + esc(stack.price) + '</button>';
      } else {
        html += '<button type="button" class="ch-quiz__cta ch-quiz__cta--button" data-ch-quiz-add="items">' + (items.length > 1 ? 'Add all to cart' : 'Add to cart &middot; ' + esc(items[0].price)) + '</button>';
      }
    }
    if (rec.notes.length) {
      html += '<div class="ch-quiz__notes"><span class="ch-eyebrow">Good to know</span><ul>' + rec.notes.map((n) => '<li>' + esc(n) + '</li>').join('') + '</ul></div>';
    }
    html += '<button type="button" class="ch-quiz__back ch-quiz__retake" data-ch-quiz-retake>Retake the quiz</button>';
    resultEl.innerHTML = html;
    resultEl.hidden = false;

    const addBtn = resultEl.querySelector('[data-ch-quiz-add]');
    if (addBtn) {
      addBtn.addEventListener('click', () => {
        const lines = addBtn.getAttribute('data-ch-quiz-add') === 'stack'
          ? [{ id: stack.variantId, quantity: 1 }]
          : items.map((p) => ({ id: p.variantId, quantity: 1 }));
        if (window.CellhackCart) window.CellhackCart.add(lines);
      });
    }
    resultEl.querySelector('[data-ch-quiz-retake]').addEventListener('click', () => {
      Object.keys(answers).forEach((k) => delete answers[k]);
      resultEl.hidden = true;
      resultEl.innerHTML = '';
      steps.hidden = false;
      actions.hidden = false;
      show(0);
    });
    root.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  show(0);
})();
